import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Typography, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { createRelanceFournisseur } from '../../../api/relanceFournisseurApi';

const RelancerFournisseur = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    factureId: '',
    type: 'email',
    dateRelance: new Date().toISOString().split('T')[0],
    commentaire: '',
  });
  const [facturesImpayees, setFacturesImpayees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Charger les factures impayées depuis l'API
  useEffect(() => {
    const fetchFacturesImpayees = async () => {
      try {
        const response = await fetch('/api/factures-achat/impayees');
        const data = await response.json();
        setFacturesImpayees(data);
      } catch (err) {
        console.error("Erreur lors du chargement des factures impayées:", err);
      }
    };
    fetchFacturesImpayees();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createRelanceFournisseur(formData);
      navigate('/relances-fournisseurs');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Relancer un fournisseur
      </Typography>
      {error && <Typography color="error">{error}</Typography>}
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          <InputLabel>Facture impayée</InputLabel>
          <Select
            name="factureId"
            value={formData.factureId}
            onChange={handleChange}
            required
          >
            {facturesImpayees.map((facture) => (
              <MenuItem key={facture.id} value={facture.id}>
                {facture.numero} - {facture.fournisseur.nom} - {facture.montant} €
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          margin="normal"
          label="Date de relance"
          type="date"
          name="dateRelance"
          value={formData.dateRelance}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
          required
        />
        <FormControl fullWidth margin="normal">
          <InputLabel>Type de relance</InputLabel>
          <Select
            name="type"
            value={formData.type}
            onChange={handleChange}
            required
          >
            <MenuItem value="email">Email</MenuItem>
            <MenuItem value="courrier">Courrier</MenuItem>
            <MenuItem value="telephone">Téléphone</MenuItem>
          </Select>
        </FormControl>
        <TextField
          fullWidth
          margin="normal"
          label="Commentaire"
          name="commentaire"
          value={formData.commentaire}
          onChange={handleChange}
          multiline
          rows={4}
        />
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" color="primary" disabled={loading}>
            {loading ? 'Enregistrement...' : 'Envoyer la relance'}
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default RelancerFournisseur;
